module.exports = __webpack_public_path__ + "resources/icon_44_comment_small.1061b5ab96679f6d.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_comment_small.png
// module id = 426
// module chunks = 0 1 2 3 4